// extracted by mini-css-extract-plugin
export default {"badge":"DiscountBadge_badge__To3Cb"};